import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axiosRequest'
import './assets/css/reset.css'
import './common/font.css'
import './assets/icon/iconfont.css'
import VideoPlayer from 'vue-video-player'
import 'animate.css'
import preventReClick from './utils/preventReClick'
import moment from 'moment'
Vue.prototype.$moment = moment
Vue.use(preventReClick)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.config.productionTip = false
// 浏览器标题
// Vue.directive('title', {
//   inserted: function (el, binding) {
//     document.title = el.dataset.title
//   }
// })

router.beforeEach((to, from, next) => {
  store.dispatch('checkToken')
  // console.log('to', to, 'from', from, 'next', next)
  // if (from.fullPath) {
  // }
  // if (store.state.isLogin) {
  next()
  // } else {
  //   next()
  // }
  if (Object.keys(axios.queue).length > 0) {
    Object.keys(axios.queue).forEach(key => {
      axios.queue[key]('请求中断~')
      delete axios.queue[key]
    })
  }
})
// router.beforeEach((to, from, next) => {
// alert(to, from, next)
// 获取用户登录成功后储存的登录标志
// const getFlag = localStorage.getItem('token')
// // 如果登录标志存在且为isLogin，即用户已登录
// if (getFlag === 'isLogin') {
//   // 设置vuex登录状态为已登录
//   store.state.isLogin = true
//   next()

//   // 如果已登录，还想想进入登录注册界面，则定向回首页
//   if (!to.meta.isLogin) {
//     // iViewUi友好提示
//     // iView.Message.error('请先退出登录')
//     next({
//       path: '/home'
//     })
//   }

// // 如果登录标志不存在，即未登录
// } else {
//   // 用户想进入需要登录的页面，则定向回登录界面
//   if (to.meta.isLogin) {
//     next({
//       path: '/login'
//     })
//     // iViewUi友好提示

//   // 用户进入无需登录的界面，则跳转继续
//   } else {
//     next()
//   }
// }
// })

// Vue.directive('demo', Opt)
Vue.prototype.$axios = axios // 添加axios到Vue的原型对象上
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
